import { MapperBase } from '../../utilities/mapper-base';
import { CodingFieldResource } from '../resource/coding-field.resource';
import { EditableFieldSection } from '../ui/editable-field-section.model';
import { EditableFieldNode, EditableFieldType } from '../ui/editable-field-node.model';
import { CodingFieldTypeResourceToEditableFieldTypeMapper } from './coding-field-type-resource-to-editable-field-type.mapper';

const typeMapper = new CodingFieldTypeResourceToEditableFieldTypeMapper();

export class CodingFieldResourceToEditableFieldMapper extends MapperBase<CodingFieldResource, EditableFieldSection | EditableFieldNode> {
	map(source: CodingFieldResource): EditableFieldSection | EditableFieldNode {
		const type: EditableFieldType = typeMapper.map(source.type);
		let dest: EditableFieldSection | EditableFieldNode;

		if (type === 'section') {
			dest = new EditableFieldSection();
			dest.id = source.fieldId;
			dest.label = source.displayTitle;
			dest.caseId = source.caseId;
			dest.items = [];
			dest.rank = source.rank;
		} else {
			dest = new EditableFieldNode();
			dest.id = source.fieldId;
			dest.parentId = source.parentFieldId;
			dest.label = source.displayTitle;
			dest.type = type;
			dest.rank = source.rank;
		}
		return dest;
	}
}
